define(function(require, exports) {
    'use strict';

    // @ngInject
    exports.NotificationsModel = function($rootScope, $timeout, httpService) {
        var NotificationsModel = function(config) {

            config = config || {};
            this.notifications = [];
            this.notificationsEndpoint = config.notificationsEndpoint;
            this.closeNotificationEndpoint = config.closeNotificationEndpoint;
            this.updateReceivedEndpoint = config.updateReceivedEndpoint;
            this.polling = false;
            this.onNotificationAdded = config.onNotificationAdded;
            this.loading = false;
        };

        NotificationsModel.prototype.startPolling = function(pollInterval) {

            var self = this;

            if(this.polling) {
                return;
            }
            this.polling = true;

            var load = function() {
                var xhr = self.loadNotifications();
                xhr.success(function() {
                    self.pollingTimeout = $timeout(function() {
                        load();
                    }, pollInterval);
                });
            };

            this.pollingTimeout = $timeout(function() {
                load();
            }, pollInterval);
        };

        NotificationsModel.prototype.stopPolling = function() {
            if(this.pollingTimeout) {
                $timeout.cancel(this.pollingTimeout);
                this.polling = false;
            }
        };

        NotificationsModel.prototype.loadNotifications = function() {

            var self = this;
            var getMessagesService = httpService.getInstance({
                endpoint: this.notificationsEndpoint,
                cacheTimeout: 0
            });

            this.loading = true;

            var xhr = getMessagesService.read();

            xhr.success(function(data) {
                if(data.messages) {
                    data.messages.forEach(function(message) {
                        message.className = self.getAlertClass(message);
                        self.addNotification(message);
                    });
                }
            });

            xhr.error(function(data) {
                if(data.errors) {
                    self.errorCode = data.errors[0];
                }
            });

            xhr['finally'](function() {
                self.loading = false;
            });

            return xhr;
        };

        NotificationsModel.prototype.getAlertClass = function(notification) {
            var level = notification.level.toLowerCase();
            var is = ['info', 'severe', 'warning', 'success'].indexOf(level) > -1;

            level = level === 'severe' ? 'danger' : level;
            return 'alert-' + (is ? level : 'info');
        };

        NotificationsModel.prototype.addNotification = function(notification) {
            if (typeof notification.id !== 'string' && typeof notification.id !== 'number') {
                return;
            }

            var replaced = false;
            for(var i = 0; i < this.notifications.length && !replaced; i++) {
                var existingNotification = this.notifications[i];

                if(notification.id && existingNotification.id === notification.id || existingNotification.message === notification.message) {
                    this.notifications[i] = notification;
                    replaced = true;
                }
            }
            if(!replaced) {
                this.notifications.push(notification);

                if(typeof this.onNotificationAdded === 'function') {
                    this.onNotificationAdded.call(null, notification);
                }
            }
        };

        NotificationsModel.prototype.removeNotification = function(notificationId) {
            var notification = this.notifications.filter(function(n) {
                return n.id === notificationId;
            });
            if (notification.length) {
                this.notifications.splice(this.notifications.indexOf(notification[0]), 1);
            }
        };

        NotificationsModel.prototype.closeNotification = function(notification) {
            var self = this;
            var closeOnServer = function() {
                self.removeNotification(notification.id);
            };

            var safeToClose = function() {
                return $timeout(function() {
                    if(!self.loading) {
                        closeOnServer();
                    } else {
                        safeToClose();
                    }
                }, 100);
            };
            return safeToClose();
        };

        NotificationsModel.prototype.getNotificationById = function(id) {
            return this.notifications.filter(function(notification) {
                return notification.id === id;
            })[0] || null;
        };

        return {
            getInstance: function(config) {
                return new NotificationsModel(config);
            }
        };
    };
});



// WEBPACK FOOTER //
// ./scripts/factories.js